import { useMutation } from '@tanstack/react-query';

import type {
  BasicEventMutationData,
  BasicEventMutationResponse,
  NoteMutationData,
  NoteMutationResponse,
  TimeBlockEventMutationData,
  TimeBlockEventMutationResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

// Basic Event mutations
export const useBasicEventMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: BasicEventMutationData;
    }) =>
      HttpClient.request<BasicEventMutationResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });

export const useDeleteBasicEventMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<BasicEventMutationResponse>({
        method: 'DELETE',
        url,
      }),
  });

// Time Block Event mutations
export const useTimeBlockEventMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: TimeBlockEventMutationData;
    }) =>
      HttpClient.request<TimeBlockEventMutationResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });

export const useDeleteTimeBlockEventMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<TimeBlockEventMutationResponse>({
        method: 'DELETE',
        url,
      }),
  });

// Note mutations
export const useNoteMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: NoteMutationData;
    }) =>
      HttpClient.request<NoteMutationResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });

export const useDeleteNoteMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<NoteMutationResponse>({
        method: 'DELETE',
        url,
      }),
  });
